import { CorporateLifecycleApi } from '@blank/api'
import { ProgressBar } from 'modules/common/components/_ui/ProgressBar'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { Corporate } from 'modules/corporate/types/corporates'
import { useInternalAccountOpeningCardProgressBar } from './hooks/useInternalAccountOpeningCardProgressBar'

interface Props {
  lifecycle: CorporateLifecycleApi
  corporate: Corporate
}
export const AccountOpeningCardProgressBar = ({
  lifecycle,
  corporate,
}: Props) => {
  const { t } = useTranslation('home-components')

  const {
    isStepWithProgressBar,
    progressBarCurrent,
    progressBarFill,
    progressBarTotal,
  } = useInternalAccountOpeningCardProgressBar({ corporate, lifecycle })

  if (!isStepWithProgressBar) {
    return null
  }

  return (
    <div className="flex flex-col gap-2 py-2">
      <ProgressBar fill={progressBarFill} color="primary" />
      <p className="text-sm leading-6 text-info-400">
        {t('accountOpeningCard.progressBarLabel', {
          context: lifecycle.nextAction,
          current: progressBarCurrent,
          total: progressBarTotal,
        })}
      </p>
    </div>
  )
}
